import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as projectReducer from "containers/Project/reducer";
import * as monitoringReducer from "containers/Monitoring/reducer";
import * as runReducer from "containers/Run/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as loginReducer from "containers/Login/reducer";

import Model from "components/Business/ModelBox/Model";

class MiniModelContainer extends React.PureComponent {
  render() {
    return <Model {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setIsAllowedInFrontier: (modelName, isAllowed) =>
      dispatch(projectReducer.setIsAllowedInFrontier(ownProps.runId, modelName, isAllowed)),
    updateIgnoredModel: (model, value) => dispatch(setupReducer.updateIgnoredModel(ownProps.runId, model, value)),
    updateShowImpact: (runId, showImpact) => dispatch(setupReducer.updateShowImpact(runId, showImpact)),
    updateScenarioSegmentFeedback: (feedback) =>
      dispatch(projectReducer.updateScenarioSegmentFeedback(ownProps.projectId, ownProps.runId, feedback)),
    postComment: (comment) =>
      dispatch(projectReducer.postScenarioSegmentComment(ownProps.projectId, ownProps.runId, comment)),
    updateModelFeedback: (runId, modelId, isLiked) =>
      dispatch(projectReducer.updateModelFeedback(runId, modelId, isLiked))
  };
};

const mapStateToProps = (state, ownProps) => {
  const runId = ownProps.runId;
  const modelId = ownProps.model && ownProps.model.id ? ownProps.model.id : null;

  const overallRunId = projectReducer.getOverallRunId(state, ownProps.projectId);

  const segmentId = projectReducer.getSegmentId(state, ownProps.projectId, runId);

  let optimized = ownProps.optimized;
  if (!optimized || Number(optimized.id) !== Number(ownProps.projectId)) {
    optimized = projectReducer.getOptimized(state, ownProps.projectId);
  }
  const modelTopDrivers = ownProps.model && ownProps.model.id && projectReducer.getTopDriversByModel(ownProps.model);

  const userId = loginReducer.getUserID(state);

  return {
    optimized: optimized,
    segmentId: segmentId,
    isContinuous: setupReducer.getIsContinuous(state, runId),
    modelIsAllowedInFrontier: projectReducer.getIsAllowedInFrontier(state, runId, modelId),
    userId: loginReducer.getUserID(state),
    scenarioSegmentFeedback: projectReducer.getScenarioSegmentFeedback(state, ownProps.projectId, runId),
    setupLabels: setupReducer.getSetupLabels(state, runId),
    setup: setupReducer.getSetup(state, runId),
    overallSetup: setupReducer.getSetup(state, overallRunId),
    allScenarios: projectReducer.getAllScenarios(state, ownProps.projectId),
    modelTopDrivers: modelTopDrivers,
    latestData: monitoringReducer.getLatestData(state, ownProps.projectId),
    monitoringData: monitoringReducer.getData(state, ownProps.projectId),
    latestScenario: monitoringReducer.getLatestScenarios(state, ownProps.projectId),
    compliancePlot: monitoringReducer.getCompliancePlot(state, ownProps.projectId, segmentId),
    userCompliancePlot: monitoringReducer.getCompliancePlot(state, ownProps.projectId, segmentId, userId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MiniModelContainer);
